import { pilot } from '~/services/serviceInstances';

export type ClauseSuggestions = {
  suggestions: string[];
};

export const getClauseSuggestions = (): Promise<ClauseSuggestions> =>
  pilot.get('/search/suggestion/provision-type/');
